"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Search = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.50977 4.82422C5.76237 4.82422 5.12435 5.08854 4.5957 5.61719C4.06705 6.14584 3.80273 6.78385 3.80273 7.53125C3.80273 8.27865 4.06705 8.91666 4.5957 9.44531C5.12435 9.97396 5.76237 10.236 6.50977 10.2314C7.25717 10.2314 7.89518 9.96713 8.42383 9.43848C8.95248 8.91439 9.21452 8.27865 9.20996 7.53125C9.21452 6.78385 8.95248 6.14584 8.42383 5.61719C7.89518 5.08854 7.25717 4.82422 6.50977 4.82422ZM6.50977 12.0225C5.68945 12.0225 4.93295 11.8242 4.24023 11.4277C3.55208 11.0267 3.00749 10.4798 2.60645 9.78711C2.2054 9.0944 2.0026 8.34017 1.99805 7.52441C1.99805 6.70865 2.20084 5.95671 2.60645 5.26855C3.00749 4.5804 3.55208 4.03581 4.24023 3.63477C4.92383 3.23372 5.67578 3.03092 6.49609 3.02637C7.31641 3.02637 8.07291 3.22689 8.76562 3.62793C9.45834 4.02442 10.0052 4.56901 10.4062 5.26172C10.8073 5.95443 11.0055 6.71093 11.001 7.53125C11.001 8.35157 10.7845 9.11946 10.3516 9.83496L12.9766 12.46L11.4316 13.998L8.80664 11.373C8.0957 11.806 7.33008 12.0225 6.50977 12.0225Z",
    clipRule: "evenodd"
  })));
};